import * as tslib_1 from "tslib";
import { Utils } from 'cc-common';
import { deserialize, serialize, Type } from 'class-transformer';
import { DynamicDashboardSection } from './dynamic-dashboard-section';
import { SharedWorkspaceResultDto } from './shared-workspace-result-dto';
export class DashboardTableEntry {
}
export var DashboardViewMode;
(function (DashboardViewMode) {
    DashboardViewMode["Scroll"] = "Scroll";
    DashboardViewMode["Carousel"] = "Carousel";
})(DashboardViewMode || (DashboardViewMode = {}));
const ɵ0 = () => DynamicDashboardSection, ɵ1 = () => SharedWorkspaceResultDto;
export class DynamicDashboardEntry {
    constructor() {
        this.isSystem = false;
        this.isShared = false;
        this.noOfSections = 1;
        this.viewMode = DashboardViewMode.Carousel;
        this.autoFitView = false;
        this.allowExternalUsers = false;
        this.dashboardSections = [new DynamicDashboardSection()];
    }
    static fromSharedWorkspace(rec) {
        const entry = deserialize(DynamicDashboardEntry, rec.config);
        entry.id = rec.id;
        entry.name = rec.name;
        entry.isSystem = rec.isSystemType;
        entry.sharedWorkspace = deserialize(SharedWorkspaceResultDto, rec.toConfigString());
        entry.allowExternalUsers = rec.allowExternalUsers;
        return entry;
    }
    get hasSharedWorkspace() {
        return Utils.notNullAndDefined(this.sharedWorkspace);
    }
    get totalWidth() {
        let width = 0;
        if (Utils.equals(this.viewMode, DashboardViewMode.Scroll)) {
            width = Math.max(...this.dashboardSections.map((ds) => Math.max(ds.width || 0, ds.itemsWidth)));
        }
        return width;
    }
    get totalHeight() {
        let height = 0;
        if (Utils.equals(this.viewMode, DashboardViewMode.Scroll)) {
            height = this.dashboardSections.map((ds) => Math.max(ds.height || 0, ds.minHeight)).reduce((x, y) => x + y);
        }
        return height;
    }
    resetRatios() {
        this.dashboardSections.forEach((ds) => {
            ds.height = null;
            ds.resetRatios();
        });
    }
    toStorageString() {
        const json = this.toJson();
        json.sharedWorkspace = this.hasSharedWorkspace ? this.sharedWorkspace.toJson() : null;
        return serialize(json);
    }
    toConfigString() {
        return serialize(this.toJson());
    }
    toJson() {
        return {
            id: this.id,
            name: this.name,
            isDefault: this.isDefault,
            isSystem: this.isSystem,
            isShared: this.isShared,
            noOfSections: this.noOfSections,
            viewMode: this.viewMode,
            autoFitView: this.autoFitView,
            allowExternalUsers: this.allowExternalUsers,
            dashboardSections: this.dashboardSections.map((ds) => {
                return {
                    layout: ds.layout,
                    width: ds.width,
                    height: ds.height,
                    dashboardItems: ds.dashboardItems.map((di) => {
                        return {
                            id: di.id,
                            title: di.title,
                            helpLink: di.helpLink,
                            widgetId: di.widgetId,
                            widthRatio: di.widthRatio,
                            heightRatio: di.heightRatio,
                            minWidthRatio: di.minWidthRatio,
                            minHeightRatio: di.minHeightRatio,
                            minWidth: di.minWidth,
                            minHeight: di.minHeight,
                            hideFullScreen: di.hideFullScreen
                        };
                    })
                };
            })
        };
    }
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", Array)
], DynamicDashboardEntry.prototype, "dashboardSections", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", SharedWorkspaceResultDto)
], DynamicDashboardEntry.prototype, "sharedWorkspace", void 0);
export { ɵ0, ɵ1 };
